module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "restricted-input"
  }, [(_vm.fieldLabel) ? _c('label', [_vm._v(_vm._s(_vm.fieldLabel))]) : _vm._e(), _vm._v(" "), (_vm.instructionsLabel) ? _c('label', {
    staticClass: "instructions-label"
  }, [_vm._v(_vm._s(_vm.instructionsLabel))]) : _vm._e(), _vm._v(" "), _c('label', {
    class: _vm.getColor(),
    attrs: {
      "data-limit": ((_vm.inputValue.length) + "/" + _vm.limit)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "restricted-input form-control",
    class: {
      'input-with-label': _vm.showLimit
    },
    attrs: {
      "id": "primaryInput",
      "type": "text",
      "maxlength": _vm.limit,
      "placeholder": _vm.placeholderText,
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "focus": _vm.enableShowLimit,
      "blur": _vm.disableShowLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputValue.length === _vm.limit && _vm.showLimit),
      expression: "inputValue.length === limit && showLimit"
    }],
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.errorMessage))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c0b518","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formControls/RestrictedSingleInput.vue
// module id = 2143
// module chunks = 1